import { getImproveAPI } from "../gen";
import { useImproveAxios } from "../../hooks/useImproveAxios";
import { useQuery } from "@tanstack/react-query";
import type { ICourseLibraryBannerResponse } from "@/types/courseLibraryBanner";

export const COURSE_LIBRARY_BANNER_QUERY_KEY = "course-library-banner" as const;

/**
 * Fetches course library banner content.
 * Thin React Query wrapper around generated API client.
 */
export const useGetCourseLibraryBanner = () => {
	const axiosConfig = useImproveAxios();
	const { courseLibraryBannerControllerGetBanner } = getImproveAPI();

	return useQuery<ICourseLibraryBannerResponse>({
		queryKey: [COURSE_LIBRARY_BANNER_QUERY_KEY],
		queryFn: async () => {
			const response = await courseLibraryBannerControllerGetBanner(axiosConfig);
			return (response as unknown as { data: ICourseLibraryBannerResponse }).data;
		},
		staleTime: 5 * 60 * 1000,
	});
};
